<script lang="ts">
	import { getToastState } from './toast-state.svelte';
	import Toast from './Toast.svelte';
	import { flip } from 'svelte/animate';

	const toastState = getToastState();
</script>

<div class="absolute right-2 top-2 flex flex-col gap-2 z-[9999]">
	{#each toastState.toasts as toast (toast.id)}
		<Toast {toast} />
	{/each}
</div>
